export * from './outfits'


// WEBPACK FOOTER //
// ./src/templates/index.js